import { render, staticRenderFns } from "./FormExpandManage.vue?vue&type=template&id=9a4a2400&scoped=true&"
import script from "./FormExpandManage.vue?vue&type=script&lang=js&"
export * from "./FormExpandManage.vue?vue&type=script&lang=js&"
import style0 from "./FormExpandManage.vue?vue&type=style&index=0&id=9a4a2400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a2400",
  null
  
)

export default component.exports